<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="400" v-model="showAddEditModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">{{ modalIcon }}</v-icon>
              <span class="modal-title-text mr-2">{{ modalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field type="text" v-model="zone.title" :autofocus="true" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="عنوان*" clearable
                clear-icon="mdi-close-circle-outline" class="input-label" prepend-inner-icon="mdi-text-box mdi-18px"
                tabindex="1"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="2" dense outlined
                item-text="title" item-value="id" label="شهرستان*" clearable clear-icon="mdi-close-circle-outline"
                v-model="zone.cityId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت ناحیه</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن ناحیه
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card height="74vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row>
                    <v-col cols="6" v-for="(item, index) in zoneFilteredList" :key="item.id">
                      <div class="items-back"></div>
                      <v-row no-gutters>
                        <v-col cols="1"></v-col>
                        <v-col cols="10">
                          <v-card height="11vh" class="mt-4 mr-n2">
                            <v-row no-gutters>
                              <v-col cols="2">
                                <v-row class="items-space" no-gutters></v-row>
                                <v-row no-gutters>
                                  <v-col cols="12" class="items-circle">
                                    <v-row class="items-space-above" no-gutters></v-row>
                                    <v-row no-gutters>
                                      <v-col cols="5" class="items-circle-above">
                                        <v-row no-gutters>
                                          <v-col cols="12" class="text-center items-index-space">
                                            <span class="items-index">{{ index + 1 }}</span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                      <v-spacer></v-spacer>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="8" class="items-card-text-space">
                                <v-row>
                                  <v-col cols="6">
                                    <span>عنوان:</span>
                                    <span class="pr-1">{{ item.title }}</span>
                                  </v-col>
                                  <v-col cols="6">
                                    <span>شهرستان:</span>
                                    <span class="pr-1">
                                      {{ item.city ? item.city.title : '-' }}
                                    </span>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <v-col cols="1" class="items-card-text-space text-center">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer"
                                      @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                      mdi-pencil mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>ویرایش</span>
                                </v-tooltip>
                              </v-col>
                              <v-col cols="1" class="items-card-text-space text-center">
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="darkColor" style="cursor: pointer"
                                      @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                      mdi-delete mdi-24px
                                    </v-icon>
                                  </template>
                                  <span>حذف</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';

import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import pagination from '@/Mixins/Pagination';
import zoneMixin from '@/Mixins/BaseInformation/ZoneMixin';
import cityMixin from '@/Mixins/BaseInformation/CityMixin';
import zoneHelper from '@/Helpers/BaseInformation/ZoneHelper';
export default {
  name: 'ZoneManagment',
  title: 'ناحیه',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
  },
  mixins: [pagination, ShearedMixin, zoneMixin, zoneHelper, snackBar, cityMixin],
  created() {
    this.$root.$refs.ZoneManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.getListOfCitysForOther();
      this.getAllZones();
    },
  },
  computed: {
    zoneFilteredList() {
      return this.allZones.filter((u) => {
        return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.items-back {
  background: var(--dark-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-back-add {
  background: var(--one-field-color) !important;
  position: absolute;
  height: 15vh;
  width: 13%;
  border-radius: 14px !important;
}

.items-circle {
  width: 8vh;
  height: 8vh;
  border-radius: 50% !important;
  background: white;
  margin-right: -3.7vh;
}

.items-space {
  height: 1.5vh;
}

.items-circle-above {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--dark-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-circle-above-add {
  width: 5vh;
  height: 5vh;
  border-radius: 50% !important;
  background: var(--one-field-color);
  margin-right: 1vh;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}

.items-space-above {
  height: 1.4vh;
}

.items-index {
  color: white;
}

.items-index-space {
  margin-top: 1.3vh !important;
}

.items-card-text-space {
  margin-top: 4vh;
}

.item-add-card {
  border: 2px dashed #c0d1e2 !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
